import { render, staticRenderFns } from "./commodityCollection.vue?vue&type=template&id=7d54b382&scoped=true&"
import script from "./commodityCollection.vue?vue&type=script&lang=ts&"
export * from "./commodityCollection.vue?vue&type=script&lang=ts&"
import style0 from "./commodityCollection.vue?vue&type=style&index=0&id=7d54b382&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54b382",
  null
  
)

export default component.exports